import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ValidatorService } from '../../../core/services/validator.service';
import { TranslateService } from '@ngx-translate/core';
import { Place } from '../../../core/interfaces/place.interface';

@Component({
  selector: 'app-stock-filter',
  templateUrl: './stock-filter.component.html',
  styleUrls: ['./stock-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush, // don't always check for changes, only when input changed (but there's no input here)
})
export class StockFilterComponent implements OnInit {
  filterForm: UntypedFormGroup;

  @Input() locations: Place[];

  @Input() isLoading: boolean;

  @Output() filterStock = new EventEmitter();

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.createForm();
    this.initLocations();
  }

  createForm() {
    const controlsConfig = this.getControlsConfig();
    this.filterForm = this.formBuilder.group(controlsConfig);
  }

  private initLocations() {
    if (this.filterForm && this.locations && this.locations.length == 1 && this.filterForm.get('location')) {
      this.filterForm.get('location').setValue(this.locations[0].id);

      this.filterStock.emit(this.filterForm);
    }
  }

  private getControlsConfig() {
    return {
      location: ['', [Validators.required]],
    };
  }

  filterClicked() {
    if (!this.filterForm.invalid && !this.isLoading) {
      this.filterStock.emit(this.filterForm);
    }
  }
}
